import { Navigate, Route, Routes } from "react-router-dom"
import { useMemo } from "react";
import Layout from "../Layout";
import Inventory from "../Inventory";
import Orders from "../Orders";
import CompanyPage from "../CompanyPage";
import CompanyRequest from "../CompanyPage/CompanyRequest";
import InstallerPage from "../Installer";
import VehiclePage from "../Vehicle";
import ImportData from "../ImportData";
import Users from "../UserManagement";
import Renewals from "../Renewals";
import Payment from "../Payment";
import Purchase from "../Inventory/components/Purchase";
import InstallerInventory from "../Inventory/components/InstallerInventory";
import DeviceMapping from "../Inventory/components/DeviceMapping";
import CompanyInventory from "../CompanyPage/components/CompanyInventory";
import QuotationPage from "../Quotation";
import UserRoles from "../UserManagement/components/UserRoles";
import Dashboard from "../Dashboard";
import MasterData from "../Configuration/components/MasterData";
import CompanySettings from "../Configuration";
import BillingCompany from "../Configuration/components/BillingCompany";
import TaskManagement from "../TaskManagement";
import TaskDashboard from "../TaskManagement/components/Dashboard";
import { getDefaultPageLink } from "../../utils";
import RequestSummary from "../Installer/components/RequestSummary";
import Settings from "../Configuration/components/Settings";

const AuthRoutes = ({ allowedPages }) => {
  const defaultPageLink = useMemo(() => {
    return getDefaultPageLink(allowedPages || []);
  },[allowedPages]);

  return <Routes>
    <Route exact path="/dashboard" element={<Layout><Dashboard /></Layout>} />

    {/* { Inventory page routes} */}
    <Route path="/inventory">
      <Route index element={<Layout><Inventory /></Layout>} />
      <Route index path="purchase" element={<Layout><Purchase /></Layout>} />
      <Route index path="mapping" element={<Layout><DeviceMapping /></Layout>} />
    </Route>

    {/* { Company page routes} */}
    <Route path="/companys">
      <Route index element={<Layout><CompanyPage /></Layout>} />
      <Route path="requests" element={<Layout><CompanyRequest /></Layout>} />
      <Route path="inventory" element={<Layout><CompanyInventory /></Layout>} />
    </Route>

    {/* { Billing page routes} */}
    <Route path="/billing">
      <Route index element={<Layout><Renewals /></Layout>} />
      <Route path="payment" element={<Layout><Payment /></Layout>} />
      <Route path="quotation" element={<Layout><QuotationPage /></Layout>} />
    </Route>

    {/* { Installer page routes} */}
    <Route path="/installer">
      <Route index element={<Layout><InstallerPage /></Layout>} />
      <Route path="inventory" element={<Layout><InstallerInventory /></Layout>} />
      <Route path="requests" element={<Layout><RequestSummary /></Layout>} />
    </Route>
    

    {/* User Managment Page Routes */}
    <Route path="/users">
      <Route index element={<Layout><Users /></Layout>} />
      <Route path="roles" element={<Layout><UserRoles /></Layout>} />
    </Route>
    

    {/* Configuration page routes */}
    <Route path="/configuration">
      <Route index element={<Layout><CompanySettings /></Layout>} />
      <Route path="billing-companies" element={<Layout><BillingCompany /></Layout>} />
      <Route path="master-data" element={<Layout> <MasterData /> </Layout>} />
      <Route path="settings" element={<Layout> <Settings /> </Layout>} />
    </Route>

    <Route exact path="/orders" element={<Layout><Orders /></Layout>} />
    <Route exact path="/vehicles" element={<Layout><VehiclePage /></Layout>} />
    <Route exact path="/imports" element={<Layout><ImportData /></Layout>} />

    {/* { Default route } */}
    <Route path="/" element={<Navigate to={defaultPageLink || "/dashboard"} replace />} />
    <Route path="/login" element={<Navigate to="/" />} />
    <Route path="*" element={<Navigate to="/installer" />} />

    {/* Task Management */}
    <Route path="/tasks">
      <Route index element={<Layout><TaskManagement /></Layout>}></Route>
      <Route path="dashboard" element={<Layout><TaskDashboard /></Layout>}></Route>
    </Route>
  </Routes>
}

export default AuthRoutes;